// extracted by mini-css-extract-plugin
export default {"fullWidthInput":"PHAEz3JOXAtkgg4SY1EO"};